// src/components/avatars/size.js

const SIZE_TOKEN_VALUES = {
  xs: '24px',
  sm: '32px',
  md: '40px',
  lg: '48px',
  xl: '64px'
};

export const AVATAR_SIZE_TOKENS = Object.freeze(Object.keys(SIZE_TOKEN_VALUES));

export function resolveAvatarSize(size) {
  if (size == null) {
    return { kind: 'unset', token: undefined, fluid: false, value: undefined };
  }

  if (size === 'fluid') {
    return { kind: 'fluid', token: undefined, fluid: true, value: undefined };
  }

  if (typeof size === 'string') {
    const trimmed = size.trim();
    if (trimmed.length === 0) {
      return { kind: 'unset', token: undefined, fluid: false, value: undefined };
    }

    if (AVATAR_SIZE_TOKENS.includes(trimmed)) {
      return { kind: 'token', token: trimmed, fluid: false, value: undefined };
    }

    return { kind: 'custom', token: undefined, fluid: false, value: trimmed };
  }

  if (typeof size === 'number' && Number.isFinite(size)) {
    return { kind: 'custom', token: undefined, fluid: false, value: `${size}px` };
  }

  return { kind: 'unset', token: undefined, fluid: false, value: undefined };
}
